export class CopilotMenuCommand
{
	execute(): void
	{
		throw new Error('You must implement this method.');
	}
}
